export interface Snippet {
  name: string
  code: string
}
